import { render, staticRenderFns } from "./ProductCartAssistant.vue?vue&type=template&id=32e8d1d4&"
import script from "./ProductCartAssistant.js?vue&type=script&lang=js&"
export * from "./ProductCartAssistant.js?vue&type=script&lang=js&"
import style0 from "./ProductCartAssistant.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports